module.exports = __webpack_public_path__ + "images/c1cef1c9f5747cf557e1ca691ee31fd32c07b6f623b19c1dce1a5906f677662e.svg";